import { useEffect, useState } from 'react';
import { useUserStatus } from '../../Hooks/useUserStatus';
import api from '../../utils/api';
import AlertBox from '../common/AlertBox';
import FirstTimeLoginModal from './components/FirstTimeLoginModal';
import Navbar from './components/Navbar';
import Sidebar from '../Layout/components/Sidebar';
import { styled, useMediaQuery, useTheme, Box } from '@mui/material';
import ModalValidationEmail from '../LayoutPlayground/components/ModalValidationEmail';
import SecondNavbar from '../LayoutPlayground/components/SecondNavbar';
import { useStore } from 'zustand';
import useUsersStore from '../../store/profile/useUsersStore';
import useUsersFacade from '../../store/profile/useUsersFacade';
import { useConfig } from '../../Hooks/useConfig';
import { getCookie, setCookie } from '../../utils/cookies';
import FallbackUI from '../Layout/components/FallbackUI';
import LayoutWithBanner from '../LayoutWithBanner';
import ChristmasBanner from '../ChristmasBanner';
import {
  PageTitleProvider,
  usePageTitleContext,
} from '../../context/PageTitleContext';

const MainContainer = styled('div')(({ theme, open }) => ({
  width: 'calc(100% - 234px)',
  marginRight: theme.direction !== 'ltr' ? 'auto' : null,
  marginLeft: theme.direction !== 'rtl' ? 'auto' : null,
  // minHeight: 'calc(100vh)',
  marginBottom: theme.spacing(0),
  // backgroundColor: 'red',
  // background: 'yellow',
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),

  // paddingRight: theme.spacing(2),
  [theme.breakpoints.down('md')]: {
    paddingLeft: theme.spacing(0),
    paddingRight: theme.spacing(0),
    width: '100%',
  },
  ...(!open && {
    [theme.breakpoints.up('md')]: {
      width: 'calc(100% - 72px) !important',
    },
  }),
}));
const ContentMain = styled('main')(({ theme, open }) => ({
  display: 'flex',
  flexDirection: 'column',
  padding: theme.spacing(6, 4),
  margin: theme.spacing(2.25, -1.75, 4.25, 4),
  background: theme.palette.mode === 'dark' ? '#222' : '#F9FCFF',
  minHeight: 'calc(100vh)',

  borderRadius: theme.spacing(4),
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(3),
    marginLeft: theme.spacing(0),
    marginBottom: theme.spacing(0),
    margin: theme.spacing(1, 0, 4.25, 0),
  },
}));

const Header = styled('div')(({ theme, smDown, mdDown, lgDown, xlDown }) => {
  // Determine font size based on breakpoints
  let fontSize = '26px';
  let lineHeight = '36px';
  let marginBottom = theme.spacing(4);
  let paddingBottom = theme.spacing(4);
  let fontWeight = 600;

  if (smDown) {
    fontSize = '16px';
    lineHeight = '24px';
    marginBottom = theme.spacing(2);
    paddingBottom = theme.spacing(2);
    fontWeight = 700;
  } else if (mdDown) {
    fontSize = '20px';
    lineHeight = '28px';
    marginBottom = theme.spacing(2.5);
    paddingBottom = theme.spacing(2.5);
  } else if (lgDown) {
    fontSize = '18px';
    lineHeight = '32px';
    marginBottom = theme.spacing(3);
    paddingBottom = theme.spacing(3);
  } else if (xlDown) {
    fontSize = '20px';
    lineHeight = '34px';
    marginBottom = theme.spacing(3.5);
    paddingBottom = theme.spacing(3.5);
  }

  return {
    fontSize: `${fontSize} !important`,
    fontStyle: 'normal',
    fontWeight,
    lineHeight: `${lineHeight} !important`,
    color: theme.palette.primary.main,
    marginBottom,
    paddingBottom,
    borderBottom: `1px solid ${theme.palette.mode === 'dark' ? '#616161' : '#E5E5E5'}`,
  };
});

const ContentContainer = styled(Box)(({ theme }) => ({
  flex: 1,
  backgroundColor: theme.palette.mode === 'dark' ? '#262626' : '#FFF',
  border: '1px solid',
  borderColor: theme.palette.mode === 'dark' ? '#464646' : '#E5E5E5',
  borderRadius: theme.spacing(4.75),
  padding: theme.spacing(4),
  minHeight: '100%',
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(4, 2),
  },
}));

const LayoutContent = ({ children }) => {
  const theme = useTheme();
  const mdUp = useMediaQuery(theme.breakpoints.up('md'));
  const smDown = useMediaQuery(theme.breakpoints.down('sm'));
  const mdDown = useMediaQuery(theme.breakpoints.down('md'));
  const lgDown = useMediaQuery(theme.breakpoints.down('lg'));
  const xlDown = useMediaQuery(theme.breakpoints.down('xl'));
  const { userInfo, loading } = useUsersFacade();
  const { baseDomain } = useConfig();
  const [openDrawer, setOpenDrawer] = useState(true);
  const { loginState, isLogin } = useUserStatus();
  const { pageTitle } = usePageTitleContext();

  const handleDrawerOpen = () => {
    setOpenDrawer(true);
    setCookie('sidebarOpen', 'true', 34560000, baseDomain);
  };

  const handleDrawerClose = () => {
    setOpenDrawer(false);
    setCookie('sidebarOpen', 'false', 34560000, baseDomain);
  };

  useEffect(() => {
    const sidebarOpen = getCookie('sidebarOpen');
    if (!sidebarOpen) {
      handleDrawerOpen();
    } else {
      const shouldOpen = sidebarOpen === 'true';
      if (mdUp || shouldOpen) {
        setOpenDrawer(shouldOpen);
      }
    }
  }, [mdUp]);

  return (
    <>
      {/* <ChristmasBanner isSidebarOpen={openDrawer} /> */}
      <LayoutWithBanner>
        <MainContainer open={openDrawer}>
          {/* <SecondNavbar /> */}
          {!mdUp && (
            <Navbar
              handleDrawerOpen={handleDrawerOpen}
              userInfoData={userInfo}
            />
          )}
          {/* {userInfo?.email_verified_at === null ? (
          <ModalValidationEmail
            open={userInfo.email_verified_at === null}
            email={userInfo.email}
          />
        ) : null} */}

          <Sidebar
            handleDrawerClose={handleDrawerClose}
            handleDrawerOpen={handleDrawerOpen}
            open={openDrawer}
            userInfoData={userInfo}
          />
          {/* <ContentMain>{children}</ContentMain> */}
          <ContentMain>
            {!loading && !userInfo && loginState ? (
              <FallbackUI />
            ) : (
              <>
                {pageTitle.text && mdUp && (
                  <Header
                    smDown={smDown}
                    mdDown={mdDown}
                    lgDown={lgDown}
                    xlDown={xlDown}
                  >
                    {pageTitle.text}
                  </Header>
                )}
                <ContentContainer>{children}</ContentContainer>
              </>
            )}
          </ContentMain>
          {/* <FirstTimeLoginModal open={open} handleClose={handleClose} /> */}
        </MainContainer>
      </LayoutWithBanner>
    </>
  );
};

const Layout = ({ children }) => {
  return (
    <PageTitleProvider>
      <LayoutContent>{children}</LayoutContent>
    </PageTitleProvider>
  );
};

export default Layout;
